var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 386,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.224 197.743h17.498v145.935c.002.01.005.019.01.026a.07.07 0 00.021.02h88.728l-.129-87.035H292v17.481H123.874l.13 87.035H17.767a17.574 17.574 0 01-12.398-5.14 17.537 17.537 0 01-5.145-12.387V197.743z",
    fill: "#F87C56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.164 0l.36 336.654H24.788V197.666h17.497v121.507h39.72L81.666.017 99.164 0z",
    fill: "#F87C56"
  })));
}
export default SvgIconPatternThree;